import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 C930.545,0 906.667,23.8782 906.667,53.3333 L906.667,217.758 C755.322,243.149 640,374.774 640,533.333 C640,568.903 645.803,603.117 656.515,635.081 L142.857,1524.76 C63.9596,1661.42 110.781,1836.16 247.436,1915.06 C263.835,1924.52 284.804,1918.9 294.271,1902.51 L592.091,1386.67 L906.667,1386.67 L906.667,1493.33 C906.667,1522.79 930.545,1546.67 960,1546.67 C989.455,1546.67 1013.33,1522.79 1013.33,1493.33 L1013.33,1386.67 L1327.7,1386.67 L1625.52,1902.51 C1634.99,1918.9 1655.96,1924.52 1672.36,1915.06 C1809.01,1836.16 1855.84,1661.42 1776.94,1524.76 L1263.41,635.306 C1274.17,603.278 1280,568.987 1280,533.333 C1280,374.774 1164.68,243.149 1013.33,217.758 L1013.33,53.3333 C1013.33,23.8781 989.455,0 960,0 Z M960,320 C842.179,320 746.667,415.513 746.667,533.333 C746.667,651.154 842.179,746.667 960,746.667 C1077.82,746.667 1173.33,651.154 1173.33,533.333 C1173.33,415.513 1077.82,320 960,320 Z M960,853.333 C979.41,853.333 998.417,851.605 1016.87,848.294 L1266.12,1280 L1013.33,1280 L1013.33,1173.33 C1013.33,1143.88 989.455,1120 960,1120 C930.545,1120 906.667,1143.88 906.667,1173.33 L906.667,1280 L653.675,1280 L902.94,848.261 C921.456,851.594 940.525,853.333 960,853.333 Z M1674.09,1773.3 L1118.68,811.285 C1150.27,793.208 1178.49,769.898 1202.15,742.537 L1684.56,1578.1 C1721.12,1641.42 1714.6,1717.8 1674.09,1773.3 Z M235.233,1578.1 L717.726,742.394 C741.372,769.773 769.581,793.101 801.171,811.197 L245.702,1773.3 C205.192,1717.8 198.671,1641.42 235.233,1578.1 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCompassLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCompassLine, _Component);

  var _super = _createSuper(IconCompassLine);

  function IconCompassLine() {
    _classCallCheck(this, IconCompassLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCompassLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCompass",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCompassLine.displayName = "IconCompassLine";
  return IconCompassLine;
}(Component);

IconCompassLine.glyphName = 'compass';
IconCompassLine.variant = 'Line';
IconCompassLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCompassLine;
export { IconCompassLine };